import { SectionsTreeNode } from '../types';

export const findFirstPageIdInTreeNode = (startNode: SectionsTreeNode): string | null => {
  if (!startNode) {
    return null; // Node with given ID not found
  }

  function findFirstNonEmptyPageIdRecursive(node: SectionsTreeNode): string | null {
    if (node.children) {
      for (const child of node.children) {
        const result = findFirstNonEmptyPageIdRecursive(child);
        if (result) {
          return result;
        }
      }
    }
    if (node.pageIds && node.pageIds.length > 0) {
      return node.pageIds[0];
    }
    return null;
  }

  return findFirstNonEmptyPageIdRecursive(startNode);
};
